import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_54be1bc9: FaireBrandEntity = {
  token: "b_54be1bc9",
  type: "brand",
  name: "SCARFSHOP",
  avatarUrl:
    "https://cdn.faire.com/fastly/12409fd1d9fa88952b23170a0b6c819f19b46f9caea33fcbaf32b5537c7f7a9e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4eae79377bfd736afd86f1b24a39214f73091212b8a7c7257d1b0d58faf79ccd.png",
  logoUrl:
    "https://cdn.faire.com/fastly/12409fd1d9fa88952b23170a0b6c819f19b46f9caea33fcbaf32b5537c7f7a9e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4eae79377bfd736afd86f1b24a39214f73091212b8a7c7257d1b0d58faf79ccd.png",
  location: "Minneapolis, MN, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    'SCARFSHOP scarves, socks, hats and totes are dyed by hand in small batches in Minneapolis, MN.\nLow impact materials and methods are used whenever possible. \n\nKettle dying in small batches gives our fabric a rich and mottled appearance. Because each item is dyed in small dye lots, a slight color variation will occur from batch to batch, and we think that’s actually kind of nice.\n\nWe have an almost zero waste product in terms of fabric. Our wool and organic cotton scarves are zero waste. Our cotton & GIANT cotton scarves have the selveges removed. These are saved and are being packaged for weaving goods.\n\nWe use recycled packaging materials.\n\nAll of our scarves are made to order which eliminates overproduction. We also sell all of our "mistakes" as seconds at a reduced price, so even not-perfect scarves get used :)\n\n\n\n',
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:46.816Z",
    importedBy: "entity-db-cli",
  },
};
